import React, { useState } from 'react';
import Loading from '../../../../Components/Loading';
import {
	useLazyUserHasMeddiQuery,
	useLazyWorkplaceMemberIdQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import { useAppContext } from '../../../../Services/AppContext';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import FlyerPrintButton from '../../../EArchive/Components/FlyerPrint/FlyerPrintButton/FlyerPrintButton';
import { Flyer } from '../../../EArchive/Enums/Flyer.enum';
// @ts-ignore
import styles from './HealthPlanCreateConfirm.module.scss';

interface Props {
	patientId: string;
	imageSource: string;
	text: string;
	flyerType: Flyer;
}

const HealthPlanConfirm: React.FC<Props> = ({
	patientId,
	imageSource,
	text,
	flyerType,
}) => {
	const { healthPlanUser } = useHealthPlanContext();
	const { workplaceId } = useAppContext();
	const [getWorkplaceMemberId] = useLazyWorkplaceMemberIdQuery();
	const [getUserHasMeddi] = useLazyUserHasMeddiQuery();
	const [workplaceMember, setWorkplaceMember] = useState<any>();
	const [patient, setPatient] = useState<any>();
	const [isLoading, setIsLoading] = useState(false);

	useEffectAsync(async () => {
		setIsLoading(true);

		let userId = healthPlanUser?.doctor?.id;

		if (flyerType === Flyer.MEDDI_BABY_LATAM) {
			userId = patientId;
		}

		if (flyerType === Flyer.MEDDI_DIABETES_LATAM) {
			userId = patientId;
		}

		const { workplaceMember } = await getWorkplaceMemberId({
			userId: userId,
			workplaceId: workplaceId,
		}).unwrap();
		setWorkplaceMember(workplaceMember);

		const { user } = await getUserHasMeddi({
			id: patientId,
		}).unwrap();
		setPatient(user);
		setIsLoading(false);
	}, []);

	return (
		<div className={styles.wrapper}>
			<div className={styles.greyBox}>
				<img src={imageSource} alt='checked' />
				<p>{text}</p>
			</div>
			<div className={styles.whiteBox}>
				{isLoading ? (
					<Loading />
				) : (
					workplaceMember?.id &&
					workplaceId &&
					!patient?.hasMeddi && (
						<FlyerPrintButton
							workplaceId={workplaceId}
							workplaceMemberId={workplaceMember?.id}
							flyerType={flyerType}
						/>
					)
				)}
			</div>
		</div>
	);
};

export default HealthPlanConfirm;
